/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { useSelector } from 'react-redux';
import { Button, Form, Input } from 'antd';
import {AddressModel} from "../models/address.model";

const layout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 20 },
};
const tailLayout = {
    wrapperCol: { offset: 8, span: 16 },
};

type Props = {
    setBillAddress: (values: AddressModel) => void
    billingData : {
        billAddress1: string,
        billAddress2: string,
        billCity: string
    }
}

const BillingAddressForm = ({ setBillAddress, billingData }: Props) => {

    return (
        <React.Fragment>
            <div>
                <div className="card-body gws__body">
                    <h4 className="gws-title">Billing Address</h4>
                    <Form
                        {...layout}
                        name="address-form"
                        style={{ maxWidth: 600, marginInline: 'auto', textAlign: 'left' }}
                        initialValues={{ remember: true }}
                        onFinish={setBillAddress}
                        autoComplete="off"
                        labelAlign={"right"}
                    >
                        <Form.Item
                            label="Address 1"
                            name="address1"
                            initialValue={billingData.billAddress1}
                            rules={[
                                {
                                    required: true,
                                    message: 'You can\'t keep this as empty.',
                                }
                            ]}
                        >
                            <Input placeholder="Type the Address 1" />
                        </Form.Item>
                        <Form.Item
                            label="Address 2"
                            name="address2"
                            initialValue={billingData.billAddress2}
                            rules={[
                                // {
                                //     required: true,
                                //     message: 'You can\'t keep this as empty.',
                                // }
                            ]}
                        >
                            <Input placeholder="Type the Address 2" />
                        </Form.Item>
                        <Form.Item
                            label="City"
                            name="city"
                            initialValue={billingData.billCity}
                            rules={[
                                {
                                    required: true,
                                    message: 'You can\'t keep this as empty.',
                                }
                            ]}
                        >
                            <Input placeholder="Type the City" />
                        </Form.Item>
                        <Form.Item {...tailLayout} className={"wizard-action"}>
                            <Button type="primary" htmlType="submit" className={"btn btn-primary btn-sm"}>
                                Next
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </React.Fragment>
    );
}

export default BillingAddressForm;